import { Link } from "@inertiajs/react"
import type { ReactNode } from "react"
import { Toaster } from "@/components/ui/sonner"
import FlashMessages from "@/components/flash-messages"
import GoogleOneTap from "./google-one-tap"

export default function AuthLayout({
  children,
  heading,
  subheading,
}: {
  children: ReactNode
  heading: string
  subheading?: string
}) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-cream px-4 py-12">
      <GoogleOneTap />
      <FlashMessages />
      <Toaster position="top-right" richColors />

      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="mb-8 text-center">
          <Link
            href="/"
            className="inline-flex items-baseline text-3xl font-display font-semibold tracking-tight"
          >
            <span className="text-charcoal">Quite</span>
            <span className="text-red">Right.</span>
          </Link>
        </div>

        {/* Card */}
        <div className="rounded-2xl border border-stone/60 bg-white px-8 py-10 shadow-sm">
          <div className="mb-8 text-center">
            <h1 className="font-display text-2xl font-semibold text-charcoal">
              {heading}
            </h1>
            {subheading && (
              <p className="mt-2 text-sm text-warm-grey">{subheading}</p>
            )}
          </div>

          {children}
        </div>
      </div>
    </div>
  )
}
